import { FIELD_WIDTH } from '@fox/atoms/contracts/field';
import { Select } from '@fox/atoms/src/select/index';
import type { FilterConditionItemProps } from './types';

export function FilterModifier<T>({
	filter,
	onChange,
	operator,
	filterType
}: Pick<FilterConditionItemProps, 'filter' | 'operator'> & { onChange: (e: string) => void; filterType?: string }) {
	const contraintOptions = operator?.filterConstraints?.filter(f => {
		const match = operator.appliesTo?.[f];
		if (match) {
			return match.includes(filterType);
		}
		return true;
	});
	return (
		<Select<string, false, true, false>
			style={{ width: FIELD_WIDTH }}
			options={contraintOptions ?? []}
			size="small"
			disableClearable={true}
			value={filter?.constrT}
			onChange={(_, v) => onChange(v)}
			getOptionLabel={o => operator?.humanNames?.[o] ?? o}
		/>
	);
}
